<!--
    描述：用户组列表
    时间：2020-04-26
    Created by yefan
-->
<template>
	<div class="h100">
		<div class="w-page-main">
			<div class="w-page-header superiors-search-area">
				<div class="left-text overflow-hidden">
					<span><b>用户组列表</b></span>
				</div>
				<div class="btnGroups">
					<el-button type="primary"
							   size="small"
							   v-if="roleBtns.includes('user_group_add')"
							   @click="doClick('add')">新增
					</el-button>
					<el-button type="warning"
							   class="ml10"
							   size="small"
							   v-if="roleBtns.includes('user_group_delete')"
							   @click="doClick('batchDel')">删除
					</el-button>
				</div>
			</div>
			<div class="w-page-container">
				<div class="w-table-layout w-table-page">
					<div class="w-table-content"
						 ref="groupsContent">
						<el-table ref="userGroupTable"
								  v-loading="usersGroupData.loading"
								  :data="usersGroupData.tableData"
								  :border="true"
								  :height="usersGroupData.tableH"
								  highlight-current-row
								  @row-click="rowClick">
							<el-table-column type="selection"
											 width="50"></el-table-column>
							<el-table-column prop="sname"
											 align="center"
											 label="组名称"
											 show-overflow-tooltip
											 min-width="120"></el-table-column>
							<el-table-column prop="groupTypeName"
											 align="center"
											 label="组类型"
											 show-overflow-tooltip
											 min-width="120"></el-table-column>
							<el-table-column label="操作"
											 align="center"
											 width="100"
											 show-overflow-tooltip>
								<template slot-scope="scope">
									<el-button size="mini"
											   icon="el-icon-edit"
											   title="编辑"
											   v-if="roleBtns.includes('user_group_edit')"
											   type="text"
											   @click="doClick('edit', scope.row)"></el-button>
									<el-button size="mini"
											   icon="el-icon-search"
											   title="查看"
											   v-if="roleBtns.includes('user_group_view')"
											   type="text"
											   @click="doClick('view', scope.row)"></el-button>
									<el-button size="mini"
											   icon="el-icon-delete"
											   title="删除"
											   type="text"
											   v-if="!scope.row.children && roleBtns.includes('user_group_delete')"
											   @click="doClick('delete', scope.row)"></el-button>

									<!-- <el-dropdown @command="doClick($event,scope.row)">
										<span class="el-dropdown-link"><i class="el-icon-more"></i></span>
										<el-dropdown-menu slot="dropdown">
											<el-dropdown-item command="edit">编辑</el-dropdown-item>
											<el-dropdown-item command="view">查看</el-dropdown-item>
											<el-dropdown-item v-if="!scope.row.children"
															  command="delete">删除
											</el-dropdown-item>
										</el-dropdown-menu>
									</el-dropdown> -->
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="w-table-footer text-center">
						<el-pagination @size-change="handleSizeChange"
									   @current-change="handleCurrentChange"
									   :current-page="usersGroupData.currentPage"
									   :page-sizes="usersGroupData.pageList"
									   :page-size="usersGroupData.pageSize"
									   layout="total, sizes, prev, pager, next, jumper"
									   :total="usersGroupData.total"></el-pagination>
					</div>
				</div>
			</div>
		</div>
		<!-- 新增、编辑等弹窗 -->
		<el-dialog :title="dialogObj.title"
				   :visible.sync="dialogObj.visible"
				   :width="dialogObj.width"
				   :mode="dialogObj.mode"
				   :close-on-click-modal="false"
				   destroy-on-close>
			<!-- 弹窗组件 -->
			<addUserGroup ref="addUserGroup"
						  :mode="dialogObj.mode"
						  :userGroupId="userGroupId"
						  v-if="dialogObj.visible"
						  @dialogClose="handleClose"></addUserGroup>
			<!-- footer 组件 -->
			<div slot="footer"
				 class="dialog-footer text-center"
				 v-if="dialogObj.mode !== 'view'">
				<el-button size="small"
						   @click="dialogObj.visible = false">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="btnLoading"
						   @click="doSave">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import { getPageGroups, deleteSysGroups } from '@/api/modules/group.js'
import addUserGroup from './add_user_group_dialog'

export default {
	components: {
		addUserGroup
	},

	data() {
		return {
			usersGroupData: {
				loading: false,
				tableH: 400,
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				pageList: [10, 20, 50, 100] // 显示条数数组
			},
			dialogObj: {
				title: '添加用户组',
				visible: false,
				width: '400px',
				mode: 'add'
			},
			userGroupId: '',
			btnLoading: false
		}
	},

	methods: {
		getUserGroups() {
			let param = {}
			param.current = this.usersGroupData.currentPage
			param.size = this.usersGroupData.pageSize
			getPageGroups(param).then(res => {
				this.usersGroupData.tableData = res.data.records
				this.usersGroupData.total = parseInt(res.data.total)
				this.$refs.userGroupTable.setCurrentRow(res.data.records[0])
				this.rowClick(res.data.records[0])
			})
		},

		// 关闭弹窗事件
		handleClose() {
			this.dialogObj.visible = false
			this.getUserGroups()
		},

		// 确定按钮事件
		doSave() {
			this.$refs.addUserGroup.doSave()
		},

		//行点击事件
		rowClick(row) {
			this.$emit('groupTableRowClick', row)
		},

		//批量删除
		batchDelete() {
			let array = this.$refs.userGroupTable.selection
			if (!array.length > 0) {
				this.$message.warning('请勾选要删除的数据！')
				return
			}
			this.$confirm('确认删除吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let idList = array.map(m => m.id)
				deleteSysGroups(idList).then(res => {
					res.code === 0
						? this.$message.success('删除成功！')
						: this.this.$message.error(res.msg)
					this.this.getUserGroups()
				})
			})
		},

		//操作事件
		doClick(type, row) {
			if (type === 'delete') {
				this.$confirm('确认删除吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let array = []
					array.push(row.id)
					deleteSysGroups(array).then(res => {
						res.code === 0
							? this.$message.success('删除成功！')
							: this.this.$message.error(res.msg)
						this.getUserGroups()
					})
				})
			} else if (type === 'batchDel') {
				this.batchDelete()
			} else {
				this.dialogObj.visible = true
				this.dialogObj.mode = type
				if (type === 'add') {
					this.dialogObj.title = '新增用户组'
				} else if (type === 'edit') {
					this.userGroupId = row.id
					this.dialogObj.title = '编辑用户组'
				} else if (type === 'view') {
					this.userGroupId = row.id
					this.dialogObj.title = '查看用户组'
				}
			}
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.usersGroupData.pageSize = val
			this.getUserGroups()
		},

		// 切换当前页码
		handleCurrentChange(cur) {
			this.usersGroupData.currentPage = cur
			this.getUserGroups()
		}
	},

	created() {
		this.getUserGroups()
	},

	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.usersGroupData.tableH = this.$refs.groupsContent.offsetHeight
			}, 100)
		})
	},

	// 进入缓存页面
	activated() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.usersGroupData.tableH = this.$refs.groupsContent.offsetHeight
			}, 100)
		})
	},

	computed: {
		...mapState('app', { clientSize: state => state.clientSize }),
		...mapState('menu', {
			roleBtns: state => state.roleBtns
		})
	},

	watch: {
		clientSize(val) {
			this.usersGroupData.tableH = this.$refs.groupsContent.offsetHeight
		}
	}
}
</script>
<style lang="less"></style>
